import axios from 'axios';

export const fetchMyInfoConfiguration = () => axios.get('/api/shared/MyInfoConfiguration');

export const fetchMyInfoDataCall = (authCode, clientId, includeCpf, codeVerifier) => {
  return axios({
    method: 'post',
    url: '/api/Application/myinfodata',
    data: {
      "authCode": authCode,
      "clientId": clientId,
      "includeCpf": includeCpf==='true',
      "codeVerifier": codeVerifier,
    },
    headers: { 'Content-Type': 'application/json' }
  })
};
